import React from 'react'
import { object, number, func } from 'prop-types'
import { ListItem, ListItemButton, ListItemText } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import theme from '../../../theme/Default'

const LinkItemList = ({ item, index, selectedIndex, handleListItemClick }) => {
  const navigate = useNavigate()
  const itemClick = index => {
    handleListItemClick(index)
  }

  const ListButtonStyle = {
    background:
      selectedIndex === index
        ? theme.palette.background.main + '!important'
        : 'initial',
    borderRadius: '2rem 0 0 2rem',
    marginLeft: '2rem'
  }

  const textStyle = {
    color:
      selectedIndex === index
        ? theme.palette.secondary.main + '!important'
        : theme.palette.background.main,
    marginLeft: '1.5rem'
  }
  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={() => {
          itemClick(index)
          navigate(item.path)
        }}
        selected={selectedIndex === index}
        sx={ListButtonStyle}
      >
        <ListItemText sx={textStyle} primary={item.name} />
      </ListItemButton>
    </ListItem>
  )
}

LinkItemList.propTypes = {
  item: object,
  index: number,
  selectedIndex: number,
  handleListItemClick: func
}
export default LinkItemList
